/** Rutas de autenticación: un 401 aquí es un error de credenciales, no sesión caducada. */
const AUTH_401_EXEMPT = /^\/api\/auth\/(google|login-password|verify-otp|request-password-reset|reset-password)(\/|$|\?)/;

/** ¿Debe el interceptor cerrar sesión y redirigir a /login tras un 401? */
export function shouldRedirectOn401(url: string | undefined, hasToken: boolean): boolean {
  if (hasToken) return false;
  if (url && AUTH_401_EXEMPT.test(url)) return false;
  return true;
}

/**
 * ¿El JWT ya venció? Al día siguiente el token guardado sigue ahí pero el servidor lo rechaza con un 401
 * genérico; sin esto la web se quedaba en "Acceso denegado" en lugar de pedir el login.
 */
export function isTokenExpired(token: string | null | undefined, nowMs: number = Date.now()): boolean {
  if (!token) return false;
  try {
    const b64 = token.split('.')[1]?.replace(/-/g, '+').replace(/_/g, '/');
    if (!b64) return false;
    const { exp } = JSON.parse(atob(b64)) as { exp?: unknown };
    return typeof exp === 'number' && exp * 1000 <= nowMs;
  } catch {
    return false;
  }
}

/**
 * ¿La respuesta 401 indica que la sesión fue revocada en el servidor?
 * Ocurre, por ejemplo, al cambiarle los roles al propio usuario (el backend revoca sus sesiones)
 * o al desactivarlo. Con el token ya muerto, ninguna llamada volverá a funcionar: hay que volver a entrar.
 */
export function isSessionRevoked(data: unknown): boolean {
  const msg = (data as { error?: unknown } | null | undefined)?.error;
  return typeof msg === 'string' && /^(SESSION_REVOKED|Session has been revoked)$/i.test(msg);
}
